export const allVimeoPlayers = [];
export const allYouTubePlayers = [];

const isReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)') === true ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;

function updatePauseIcons(isPlaying) {
    const buttons = document.querySelectorAll('.btn--pause');
    const iconHTML = isPlaying
        ? '<svg class="o-icon o-icon--pause"><use xlink:href="#pause"></use></svg>'
        : '<svg class="o-icon o-icon--play"><use xlink:href="#play"></use></svg>';

    buttons.forEach(button => {
        const iconContainer = button.querySelector('.btn--pause div');
        if (iconContainer) {
            iconContainer.innerHTML = iconHTML;
        }
    });
}

export function toggleAllPlayers() {
    let anyPlaying = false;
    let promises = [];

    // Vimeo
    allVimeoPlayers.forEach(player => {
        const promise = player.getPaused().then(paused => {
            if (paused) {
                player.play();
                anyPlaying = true;
            } else {
                player.pause();
            }
        }).catch(console.error);
        promises.push(promise);
    });

    // YouTube
    if (typeof window.YT !== 'undefined' && typeof window.YT.PlayerState !== 'undefined') {
        allYouTubePlayers.forEach(player => {
            const state = player.getPlayerState();
            if (state === window.YT.PlayerState.PLAYING) {
                player.pauseVideo();
            } else {
                player.playVideo();
                anyPlaying = true;
            }
        });
    }

    // After all Vimeo players resolve, update icons
    Promise.all(promises).then(() => {
        updatePauseIcons(anyPlaying);
    });
}

export function applyInitialReducedMotionState() {
    if (isReducedMotion) {
        updatePauseIcons(false); // set to "play" icon on load
    } else {
        updatePauseIcons(true);  // set to "pause" icon on load
    }
}

export function init() {
    applyInitialReducedMotionState();
}
